module.exports = __webpack_public_path__ + "a284cba8975d275b24940e8bc7755108.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-118@2x.png
// module id = 499
// module chunks = 0